import { Form, FormInstance, Select } from 'antd';
import { useListTeamClients } from 'client/modules/external-api/hooks/queries/external-api';
import { ApiApplication } from '@cbinsights/externalapiservice/externalapiservice';
import { DataFeedFormField } from './DataFeedForm';

export const apiClientCanContinue = (form: FormInstance) =>
  !!form.getFieldValue(DataFeedFormField.client);

export const APIClientTabForm = ({ idTeam }: { idTeam: string }) => {
  const { data: response } = useListTeamClients(Number(idTeam));

  const clients =
    response?.clients
      .filter(
        (el) =>
          el.api_application === ApiApplication.API_APPLICATION_DATAFEEDS &&
          el.is_active === true
      )
      .map((client) => {
        return {
          label: (
            <span>
              Client Id ....{client.client_id.slice(-10)} - Expiration Date{' '}
              {new Date(client.expiration_date).toLocaleDateString('en-US', {
                timeZone: 'UTC',
              })}
            </span>
          ),
          value: client.client_id,
        };
      }) || [];

  return (
    <>
      <div>
        Available team credits: {response?.clients[0]?.available_credits} of{' '}
        {response?.clients[0]?.total_credits}
      </div>

      <Form.Item
        name={DataFeedFormField.client}
        label="DataFeed API Client"
        required
      >
        <Select placeholder="Select an option" labelInValue options={clients} />
      </Form.Item>
    </>
  );
};
